/* eslint-disable no-shadow */
import { keyify } from '@Hooks/LibraryInitialization/MoreUnderscore';
import { createSelector } from 'reselect';

import { stateParamsSelectorFactory, previousStateParams } from '@Selectors/StateParamsSelectors';
import { commercialSuppliersFilterId } from '@Containers/ResultsFilters/ResultsFiltersConstants';
import { listOfFiltersReducerKey } from './ListOfFiltersConstants';

export function listOfFiltersState(state) {
  return state.get(listOfFiltersReducerKey);
}

// eslint-disable-next-line no-use-before-define
export const filters = createSelector([filtersItems, filtersIds], (filtersItems, filtersIds) => {
  if (!filtersItems) {
    return null;
  }

  return filtersIds.map((id) => filtersItems.get(id));
});

export const paramsForFiltersRequest = stateParamsSelectorFactory(['context', 'databaseId', 'resultName', 'hitSetKey']);

export const keyifyParamsForFiltersRequest = createSelector([paramsForFiltersRequest], (paramsForFiltersRequest) =>
  keyify(paramsForFiltersRequest)
);

export function filtersItems(state) {
  return listOfFiltersState(state).getIn([keyifyParamsForFiltersRequest(state), 'items']);
}

export function filtersIds(state) {
  return listOfFiltersState(state).getIn([keyifyParamsForFiltersRequest(state), 'ids']);
}
export const previousParamsForFiltersRequest = stateParamsSelectorFactory(
  ['context', 'databaseId', 'resultName', 'hitSetKey'],
  previousStateParams
);

export const keyifyPreviousParamsForFiltersRequest = createSelector([previousParamsForFiltersRequest], (previousParamsForFiltersRequest) =>
  keyify(previousParamsForFiltersRequest)
);

export const paramsForFilterGroups = stateParamsSelectorFactory([
  'context',
  'resultName',
  'databaseId',
  'order',
  'pageNumber',
  'query',
  'searchId',
  'sort',
  'hitSetKey',
]);

export const commercialSuppliersFilter = createSelector([filters], (filters) =>
  filters.find((filter) => filter.get('value') === commercialSuppliersFilterId)
);
